export default __webpack_public_path__ + "static/media/ready-for-loading.4e88c137.svg";